// src/component/createAccount/CreateAccount.jsx
import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Container, Row, Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import styles from "./style";
import { Typography, styled } from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { NavLink } from "react-router-dom";
import { PrimaryButton } from "../ui/Buttons";

const HeroSection = styled(Box)(({ theme }) => ({
  backgroundImage: styles.container.backgroundImage,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  minHeight: '85vh',
  display: 'flex',
  alignItems: 'center',
  padding: '64px 0',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(11, 15, 25, 0.85)' : 'rgba(255, 255, 255, 0.85)',
    zIndex: 1,
  },
}));

const HeroContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  maxWidth: '640px',
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    margin: '0 auto',
  },
}));

const CreateAccount = () => {
  return (
    <HeroSection>
      <CssBaseline />
      <Container>
        <Row>
          <Col xs={12} md={8} lg={6}>
            <HeroContent>
              <Typography 
                variant="caption" 
                color="secondary" 
                style={{ 
                  textTransform: 'uppercase', 
                  fontWeight: 700, 
                  letterSpacing: '0.15em',
                  display: 'inline-block',
                  marginBottom: '16px' 
                }}
              >
                Start Learning Today
              </Typography>
              <Typography 
                variant="h1" 
                style={{ 
                  color: 'var(--color-text-primary)', 
                  fontWeight: 800,
                  lineHeight: 1.2,
                  marginBottom: '20px'
                }}
              >
                OPPORTUNITIES DON'T HAPPEN, YOU <span style={{ color: 'var(--color-secondary)' }}>CREATE</span> THEM
              </Typography>
              <Typography 
                variant="subtitle1" 
                color="textSecondary" 
                style={{ 
                  lineHeight: 1.6, 
                  marginBottom: '32px' 
                }}
              >
                Access premium nursing course materials, clinical study notes, and professional MCQ mock tests. Prepare efficiently for licensing exams.
              </Typography>
              <NavLink to='/signup' style={{ textDecoration: 'none' }}>
                <PrimaryButton 
                  size="large" 
                  endIcon={<ArrowRightAltIcon />}
                  style={{ minWidth: '220px', height: '48px' }}
                >
                  Create your Account
                </PrimaryButton>
              </NavLink>
            </HeroContent>
          </Col>
        </Row>
      </Container>
    </HeroSection>
  );
};

export default CreateAccount;
